export default __webpack_public_path__ + "static/media/stacked.8aa3f9b6.svg";